import type { FC } from "react";
import { Form } from "react-bootstrap";
import type { PlacesAutocompleteDto } from "shared";
import { useEventCallback } from "usehooks-ts";
import type { UseFormReturn } from "../common/form/useForm";
import { Tag } from "../components/Tag";
import type { FormMyBusinessLocationFields } from "./FormBusinessLocationFields";
import { SearchGooglePlaces } from "./SearchGooglePlaces";

type Props = {
	form: UseFormReturn<FormMyBusinessLocationFields>;
};

export const FormBusinessServiceArea: FC<Readonly<Props>> = ({ form }) => {
	const handleAddServiceArea = useEventCallback(
		(placeDto: PlacesAutocompleteDto) => {
			const serviceAreas = form.values?.serviceAreas ?? [];
			if (
				serviceAreas.some(
					(area) => area.placeId === placeDto.placePrediction?.placeId,
				)
			) {
				return;
			}
			serviceAreas.push({
				place: placeDto.placePrediction?.text?.text ?? "",
				placeId: placeDto.placePrediction?.place ?? "",
			});
			form.setFieldValue("serviceAreas", serviceAreas);
		},
	);

	const handleRemoveServiceArea = useEventCallback((placeId?: string) => {
		const serviceAreas = form.values?.serviceAreas ?? [];
		const newServiceAreas = serviceAreas.filter(
			(area) => area.placeId !== placeId,
		);
		form.setFieldValue("serviceAreas", newServiceAreas);
	});

	return (
		<>
			<div className="mb-3">
				<Form.Check
					className="business-type-check"
					type="radio"
					name="business-type"
					id="business-type-cust-only"
					label="I serve customers at their location"
					onChange={() =>
						form.setFieldValue("businessType", "CUSTOMER_LOCATION_ONLY")
					}
					checked={form.values.businessType === "CUSTOMER_LOCATION_ONLY"}
				/>
				<Form.Check
					className="business-type-check"
					type="radio"
					name="business-type"
					id="business-type-both"
					label="I serve customers at my and their location"
					onChange={() =>
						form.setFieldValue("businessType", "CUSTOMER_AND_BUSINESS_LOCATION")
					}
					checked={
						form.values.businessType === "CUSTOMER_AND_BUSINESS_LOCATION"
					}
				/>
			</div>
			<SearchGooglePlaces onChange={handleAddServiceArea} className="mb-3" />

			{!!form.values?.serviceAreas?.length && (
				<Tag.List>
					{form.values.serviceAreas?.map((area) => (
						<Tag
							key={area.place}
							name={area.place}
							onRemove={() => handleRemoveServiceArea(area.placeId)}
						/>
					))}
				</Tag.List>
			)}
		</>
	);
};
